module.exports = __webpack_public_path__ + "static/logo-32d22fe55008c75fefcf596226049578.png";